export * from './tabs';
export { default } from './tabs';
